import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Facet extends Component {

  constructor(props) {
    super(props);
    this.translationUtility = props.translationUtility
  }

  onValueClick = (value) => {
    const {
      Name,
      onAttributeChange,
    } = this.props;

    onAttributeChange(Name, value);
  }

  render() {

    const {
      Values,
      DisplayName,
    } = this.props;

    return (
      <div className="form-group">
        <h4 className="checkbox-facets__name">{DisplayName}</h4>

          {Values.map((value, i) => {

            const id = `${DisplayName}-${value.Name}`.replace(' ', '-');

            const onClickHandler = (event) => {
              event.preventDefault();

              this.onValueClick(value.Name);
            }

            return (
              <div className="form-check" key={id}>
                <input 
                  type="checkbox" 
                  className="form-check-input" 
                  checked={value.Checked}
                  id={id}
                  onClick={onClickHandler}/>
                <label 
                  className="form-check-label" 
                  htmlFor={id}
                  onClick={onClickHandler}>{value.Name} ({value.Count})</label>
              </div>
            )
          })}          

      </div>
    );
  }

}

Facet.propTypes = {
  translationUtility: PropTypes.object.isRequired
}

export default Facet;


// WEBPACK FOOTER //
// ./src/Components/search/Features/CheckboxFacets/Facet.jsx